import TAPS_API from 'services/TAPS_API';

export const percentDepositsApplicationDraft = (data) => {
  return TAPS_API.request({
    url: '/edms/percentDeposits/draft',
    method: 'POST',
    data,
  });
};

export const percentDepositsApplication = (data) => {
  return TAPS_API.request({
    url: '/edms/percentDeposits/confirm',
    method: 'POST',
    data,
  });
};
